
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function IdiopathicThrombocytopenicPurpura(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Idiopathic Thrombocytopenic purpura"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Idiopathic thrombocytopenic purpura is a <b> blood disorder characterized
                                    by an abnormal decrease in the number of platelets in the blood.</b> A
                                    decrease in platelets can result in easy bruising, bleeding gums, and
                                    internal bleeding. ITP may be acute and resolve in less than 6 months, or
                                    chronic and last longer than 6 months.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Idiopathic-Thrombocytopenic-purpura/1.png")} alt="Idiopathic-Thrombocytopenic-purpura" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Immune thrombocytopenia may have no signs and symptoms. When they do occur, they may
                                    include:</p>
                                <p>Easy or excessive bruising</p>
                                <p>Superficial bleeding into the skin that appears as pinpoint-sized reddish-purple spots
                                    (petechiae) that look like a rash, usually on the lower legs</p>
                                <p>Bleeding from the gums or nose</p>
                                <p>Blood in urine or stools</p>
                                <p>Unusually heavy menstrual flow</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Immune_thrombocytopenic_purpura">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default IdiopathicThrombocytopenicPurpura;